import {Component, OnInit} from '@angular/core';
import {BreadcumbsService} from "../breadcumbs/breadcumbs.service";

@Component({
  selector: 'pbc-infobank',
  templateUrl: './infobank.component.html',
  styleUrls: ["./infobank.component.scss"]
})
export class InfobankComponent implements OnInit {

  constructor(private breadcumbsService: BreadcumbsService) { }

  ngOnInit() {
    setTimeout(()=>this.breadcumbsService.setSubfolder.emit('Infobank'),100);
  }

}
